// src/components/DataTable.js
import React, { useEffect, useState } from 'react';
import axios from 'axios';

import { API_URL, ENDPOINTS } from '../../constants/api';
import { decodeToken, getToken } from '../../utils/TokenUtils';
import HorizontalForm from '../../components/HorizontalForm';
import { groupBy } from '../../utlis';
import { CURRENT_DATE } from '../../constants';
import '../../css/permission.css';
import { useParams } from 'react-router-dom';

const UserPermission = () => {
  const [report, setReport] = useState([]);
  const [links, setLinks] = useState([]); //user permission's links

  const token = getToken();
  const userId = decodeToken(token, 'id');

  const [loading, setLoading] = useState(true);
  const { route } = useParams(); // Retrieve the param from the URL

  const [link, setLink] = useState([]);
  const [inputs, setInputs] = useState([]);
  const [values, setValues] = useState([]);
  const [message, setMessage] = useState([]);
  const [executionTime, setExecutionTime] = useState(null);

  const [reportHeader, setReportHeader] = useState([]);
  const [reportFooter, setReportFooter] = useState([]);

  useEffect(() => {
    const url = `${API_URL}/${ENDPOINTS.SYS}/createform/permission%2F${route}`;
    console.log('url:', url);
    const fetchForm = async () => {
      const initialState = {};
      try {
        const response = await axios.get(url, {
          headers: {
            Authorization: token ? `Bearer ${token}` : '',
          },
        });
        setLink(response.data.link);
        //console.log('link:', response.data.link);
        setInputs(response.data.inputs);
        console.log('inputs:', response.data.inputs);

        //Loop through form inputs and create initial key values form inputs
        response.data.inputs.map((input) => {
          if (input.type === 'file') {
            initialState[input.name] = null;
          } else if (
            input.type === 'dropdown' ||
            input.type === 'load_dropdown'
          ) {
            initialState[input.name] = '%';
          } else {
            initialState[input.name] = input.value.trim();
          }
        });

        //add default values for user_id and date
        initialState['user_id'] = userId;
        //  initialState['date'] = CURRENT_DATE;
        //Set all initial input values to the state values
        setValues(initialState);

        setLoading(false);
        // document.title = response.data.link.page_title; // Update title dynamically
      } catch (error) {
        console.error('Error fetching data:', error);
        setLink([]);
        setInputs([]);
        setLoading(false);
      }
    };

    fetchForm();

    // setLinks(groupBy(report,'category'));
  }, [route]);

  console.log('report:', report);

  const handleCheckboxChange = async (link_id, permissionID, action, event) => {
    const values2 = {
      grant_user_id: values.grant_user_id,
      user_id: userId,
      action: action,
      date: CURRENT_DATE,
      link_id: link_id,
    };
    //alert( values2.type, values2.link_id);
    console.log('vv:', values2);
    let url = '';
    if (event.target.checked) {
      url = `${API_URL}/${ENDPOINTS.SYS}/create/create-user-permission`;
      try {
        const response = await axios.post(url, values2, {
          headers: {
            Authorization: token ? `Bearer ${token}` : '',
          },
        });

        console.log('response:', response.data);
      } catch (err) {
        console.log('error:', err);
      }
    } else {
      url = `${API_URL}/${ENDPOINTS.SYS}/createcustom/delete-user-permission`;

      try {
        const response = await axios.post(url, values2, {
          headers: {
            Authorization: token ? `Bearer ${token}` : '',
          },
        });

        console.log('response:', response.data);
      } catch (err) {
        console.log('error:', err);
      }
    }
  };
  // console.log('links:', links);
  return (
    <>
      <HorizontalForm
        token={token}
        link={link}
        values={values}
        inputs={inputs}
        setData={setReport}
        setReportHeader={setReportHeader}
        setReportFooter={setReportFooter}
        setValues={setValues}
        setExecutionTime={setExecutionTime}
      />

      <div className="container">
        <div className="row">
          {report &&
            Object.keys(groupBy(report, 'category')).map((category) => (
              <div key={category} className="col-4">
                <div className="category-container">
                  <input
                    className="form-check-input"
                    type="checkbox"
                    disabled
                    // onChange={() => handleCategoryChange(category.replace(/\s/g, ''), event)}
                  />
                  <label className="form-check-label" htmlFor="exampleCheckbox">
                    &nbsp; {category}
                  </label>

                  <ul className="nested-list">
                    {groupBy(report, 'category')[category].map((item) => (
                      <li key={item.id} className="form-check">
                        <input
                          className={`form-check-input ${category.replace(/\s/g, '')}`}
                          type="checkbox"
                          defaultChecked={item.is_checked}
                          link={item.link_id}
                          id={item.id}
                          action={item.action}
                          onChange={(event) =>
                            handleCheckboxChange(
                              item.link_id,
                              item.id,
                              item.action,
                              event
                            )
                          }
                        />
                        <label
                          className="form-check-label"
                          htmlFor={`checkbox-${item.id}`}
                        >
                          {item.link}
                        </label>
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            ))}
        </div>
      </div>
    </>
  );
};

export default UserPermission;
